import { TableModel } from '@/store/models/table'
import api from '@/api'

export default TableModel({ getAll: api.BulkDelivery.getReceivers})
  .extend({
    namespaced: true
  })
